import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.57 3.05',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M1.79,2.44h0A2.45,2.45,0,0,1,1,.87.78.78,0,0,1,1.79,0a.78.78,0,0,1,.79.87,2.51,2.51,0,0,1-.75,1.56Zm0-2.32a.67.67,0,0,0-.68.75A2.29,2.29,0,0,0,1.79,2.3,2.35,2.35,0,0,0,2.46.87.66.66,0,0,0,1.79.12Z"
        />
        <path
          fill={fill}
          d="M1.79,1.35A.49.49,0,1,1,2.28.86.49.49,0,0,1,1.79,1.35Zm0-.86a.38.38,0,0,0-.38.37.38.38,0,0,0,.75,0A.38.38,0,0,0,1.79.49Z"
        />
        <path
          fill={fill}
          d="M3.51,3.05H.06L0,3A.11.11,0,0,1,0,3L.54,1.1s0,0,.06,0H.85a.06.06,0,1,1,0,.12H.64L.14,2.93H3.43l-.5-1.75H2.7a.06.06,0,0,1,0-.12H3A.08.08,0,0,1,3,1.1L3.57,3s0,0,0,0Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
